import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { EnTetePage } from "../components/EnTetePage";
import { CarteFormation } from "../components/CarteFormation";
import { CallToAction } from "../components/CallToAction";
import { formations } from "../data/mockData";

/** Page de section : le catalogue complet des formations. */
export const FormationsPage = () => (
  <>
    <EnTetePage
      chemin={[["Accueil", "/"]]}
      titre="Nos formations"
      chapo="QGIS, FME, PostGIS, Python et cartographie web : des sessions en petits groupes, en présentiel à Gatineau ou à distance, sur vos propres données lorsque c'est pertinent."
    >
      <Link to="/?sujet=formation#contact" className="btn-accent">
        Demander une session
        <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
      </Link>
      <Link to="/services/formation-accompagnement" className="btn-outline">
        Formation et accompagnement
      </Link>
    </EnTetePage>

    <section className="section">
      <div className="shell">
        <h2 className="sr-only">Le catalogue</h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {formations.map((formation) => (
            <CarteFormation key={formation.slug} formation={formation} />
          ))}
        </div>
        <p className="mx-auto mt-10 max-w-[720px] text-center leading-relaxed text-t2">
          Dates et tarifs communiqués sur demande. La formation sur mesure
          s'adapte à vos outils et à vos projets.
        </p>
      </div>
    </section>

    <CallToAction />
  </>
);
